import React from 'react';

export const TestimonialList = (props) => {
    const testimonialItems = props.children.map((testimonial) =>
        <li className={props.className}
            key={testimonial.Ordinal}
        >
            {testimonial}
        </li>
    );

    return (
        <ul id="testimonialsList">{testimonialItems}</ul>    
    );
}